import type { PageService } from "@/data/services-pages";

const SITE = "https://tokamdarius.ca";

/**
 * Le graphe d'une page service : Service, FAQPage, BreadcrumbList.
 *
 * Meme forme que schema-ville.ts, avec une seule difference de fond :
 * areaServed porte la province et non une ville. Un service vendu au Québec
 * entier n'a pas de ville a declarer, et en inventer une remettrait la fausse
 * presence locale que tout le lot s'interdit.
 *
 * Le noeud provider est decrit en entier plutot que reference, pour la raison
 * deja documentee dans schema-ville.ts : le JSON-LD de index.html ne porte
 * aucun "@id", donc une simple reference pointerait dans le vide. Les deux
 * fichiers posent le meme identifiant stable, ce qui les fait fusionner au
 * lieu de se contredire.
 */
export function schemaService(service: PageService) {
  const url = `${SITE}/services/${service.slug}`;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${url}#service`,
        name: service.nom,
        description: service.meta.description,
        serviceType: service.motsCles.principal,
        provider: {
          "@type": "Person",
          "@id": `${SITE}/#person`,
          name: "Tokam Darius",
          url: `${SITE}/`,
        },
        dateModified: service.misAJour,
        areaServed: {
          "@type": "AdministrativeArea",
          name: "Québec",
        },
        url,
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        mainEntity: service.faq.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.reponse },
        })),
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${url}#fil`,
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE}/` },
          { "@type": "ListItem", position: 2, name: "Services", item: `${SITE}/services` },
          { "@type": "ListItem", position: 3, name: service.nom, item: url },
        ],
      },
    ],
  };
}
